var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.items.length > 0
    ? _c("div", { staticClass: "recent-works-list" }, [
        _c("p", { staticClass: "recent-works-list__heading" }, [
          _vm._v(_vm._s(_vm.$t("homePage.recent.title"))),
        ]),
        _c(
          "ul",
          { staticClass: "recent-works-list__items" },
          _vm._l(_vm.items, function (item) {
            return _c(
              "li",
              { key: item.key, staticClass: "recent-works-list__item-wrapper" },
              [
                _c(
                  "button",
                  {
                    staticClass: "recent-works-list__item",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.onClickItem(item)
                      },
                    },
                  },
                  [
                    _c(
                      "span",
                      { staticClass: "recent-works-list__thumbnail" },
                      [
                        _c("image-view", {
                          staticClass: "recent-works-list__image",
                          attrs: {
                            src: item.thumbnailSrc,
                            placeholder: "/img/placeholders/novel.png",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("span", { staticClass: "recent-works-list__info" }, [
                      _c(
                        "span",
                        {
                          ref: "titleEls",
                          refInFor: true,
                          staticClass: "recent-works-list__title",
                        },
                        [_vm._v(_vm._s(_vm.displayTitle(item)))]
                      ),
                      _c(
                        "span",
                        {
                          ref: "subtitleEls",
                          refInFor: true,
                          staticClass: "recent-works-list__subtitle",
                        },
                        [_vm._v(_vm._s(_vm.displaySubtitle(item)))]
                      ),
                    ]),
                  ]
                ),
              ]
            )
          }),
          0
        ),
        _vm.isPc
          ? _c("div", { staticClass: "recent-works-list__divider" })
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }